var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"special-terms"},[_c('p',{staticClass:"special-terms__title"},[_vm._v("특약사항")]),_c('div',{staticClass:"special-terms__content"},_vm._l((_vm.items),function(item,index){return _c('p',{key:'term_' + index},[_vm._v(_vm._s(index + 1)+". "+_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }